import * as React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import isAbsoluteUrl from 'is-absolute-url';

import { useTheme } from '@emotion/react';

const prefixIfNeeded = (href, isViewer) => {
  if (!href) return href;
  // already prefixed
  if (href.startsWith('/NBH')) return href;

  // only adjust 2005 internal links
  if (href.startsWith('/2005')) {
    return isViewer ? `/NBH${href}` : href;
  }

  return href;
};

const AnchorTag = ({ children: link, ...props }) => {
  const theme = useTheme(); 
  const isViewer = theme.isViewer;

  if (!link) return null;

  const href = props.href;

  if (isAbsoluteUrl(href)) {
    return (
      <a href={href} target="_blank" rel="noopener noreferrer">
        {link}
      </a>
    );
  }

  const adjustedHref = prefixIfNeeded(href, isViewer);

  return (
    <GatsbyLink to={adjustedHref} {...props}>
      {link}
    </GatsbyLink>
  );
};

export default AnchorTag;
